import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === "ECONNABORTED" || err.message?.toLowerCase().includes("timeout")) {
      console.warn("[API] Request timeout:", err.config?.url);
    }
    return Promise.reject(err);
  }
);

export default API;
